module.exports = __webpack_public_path__ + "img/2d884caa633c469ca3256071ebbd674f.7ea7fa7f.png";